module.exports = __webpack_public_path__ + "media/images/flags/pn-0911eddaa4bb5cbf54b8d318c454fe35.svg";